<section class="dialog">

  <h1 mat-dialog-title>Howdy, thanks for joining!</h1>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
  </div>

</section>
